<div class="page-template">
  <div class="content-wrapper">
    <app-operation-mode></app-operation-mode>
    <app-header></app-header>
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
